import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, Type, ViewChild } from '@angular/core';
import { NbDialogService, NbMenuItem, NbMenuService, NbSidebarService } from '@nebular/theme';
import { NbIconLibraries } from '@nebular/theme';
import { MenuGroup } from '../editors/dynamic-input-model';
import { EditorService } from '../editors/services/editor.service';
import { SitesPickerComponent } from '../editors/dialogs/sites-picker/sites-picker.component';

@Component({
  selector: 'kve-side-bar-menues',
  templateUrl: './side-bar-menues.component.html',
  styleUrls: ['./side-bar-menues.component.scss']
})
export class SideBarMenuesComponent implements OnInit,AfterViewInit {

  menuGroups:any;
  title = "Editing Home Page Route";
  menuTag = "editHomePageRouteMenu";
  menuGroup:MenuGroup = {
    title:"Editing Home Page Route",
    menuTag:"editHomePageRouteMenu",
    menuItems:[
      /* {
        title:"Sites",
        icon:{icon:"browser-outline",pack:"eva"}
      }, */
      {
        title:"Pages",
        icon:{icon:"file-text-outline",pack:"eva"},
        children:[
          {
            title:"Home Page",
            link:'home-page',
            icon:{icon:"home-outline",pack:"eva"},
          },
          {
            title:"Category Page",
            link:'category-page',
            icon:{icon:"list-outline",pack:"eva"},
          },
          {
            title:"Product Page",
            link:'product-page',
            icon:{icon:"cube-outline",pack:"eva"}
          },
          {
            title:"Cart",
            link:'cart',
            icon:{icon:"shopping-cart-outline",pack:"eva"}
          },
          {
            title:"FAQs",
            link:'faqs',
            icon:{icon:"question-mark-circle-outline",pack:"eva"}
          },
          {
            title:"Blog",
            link:'blog',
            icon:{icon:"edit-2-outline",pack:"eva"}
          },
          {
            title:"Contact Us",
            link:'contact-us',
            icon:{icon:"email-outline",pack:"eva"}
          },
          {
            title:"About Us",
            link:'about-us',
            icon:{icon:"people-outline",pack:"eva"}
          },
          {
            title:"Store Policies",
            link:'policies',
            icon:{icon:"shield-outline",pack:"eva"}
          },
        ]
      },
      {
        title:"Layout",
        icon:{icon:"layout-outline",pack:"eva"},
        children:[
          {
            title:"Header",
            link:'header',
            icon: {icon:"browser-outline",pack:"eva"},
            skipLocationChange:true
          },
          {
            title:"Footer",
            link:'footer',
            icon: {icon:"book-outline",pack:"eva"},
            skipLocationChange:true
          },
          {
            title:"Navigation",
            link:'navigation',
            icon: {icon:"menu-2-outline",pack:"eva"},
          },
        ],
        skipLocationChange:true
      },
      {
        title:"General Settings",
        icon:{icon:"settings-outline",pack:"eva"}
        //<i class="fas fa-cog"></i>
        // <i class="far fa-object-group"></i>
      },
      
      
      
      
      {
        title:"Notifications",
        icon:{icon:"bell-outline",pack:"eva"},
        children:[
          {
            title:"News Letter",
            link:'kve/news-letter'
          },
          {
            title:"Social Media",
            link:'kve/social-media'
          }
        ]
        //<i class="far fa-bell"></i>
      },
      {
        title:"Media",
        icon:{icon:"image-outline",pack:"eva"},
        //<i class="far fa-images"></i>
      },
      {
        title:"Theme",
        icon:{icon:"color-palette-outline",pack:"eva"},
        link:'theme'
        //<i class="fas fa-palette"></i>
      }
      
      
    ]
  }
  menuItems:NbMenuItem[] = [];
  secondaryMenuItems:NbMenuItem[] = [];
 /*  menuItems:NbMenuItem[] = [
    {
      title:"General Settings",
      group:true,
      icon:{icon:"bars",pack:"fas"}
    },
    {
      title:"Layout",
      link:'kve/layout',
      icon:"layout-outline",
      skipLocationChange:true
    },
    {
      title:"Header",
      link:'kve/header',
      icon: {icon:"star",pack:"far"},
      skipLocationChange:true
    },
    {
      title:"Footer",
      link:'kve/footer',
      skipLocationChange:true
    },
    {
      title:"Navigation",
      link:'kve/navigation'
    },
    {
      title:"Pages/Routes",
      icon:{icon:"file",pack:"far"},
      children:[
        {
          title:"Home Page",
          link:'kve/home-page'
        },
        {
          title:"Category Page",
          link:'kve/category-page'
        },
        {
          title:"Product Page",
          link:'kve/product-page'
        },
        {
          title:"Cart",
          link:'kve/cart'
        },
        {
          title:"FAQs",
          link:'kve/faqs'
        },
        {
          title:"Blog",
          link:'kve/blog'
        },
      ]
    },
    
    {
      title:"Information",
      group:true
    },
    {
      title:"Contact Us",
      link:'kve/contact-us'
    },
    {
      title:"About Us",
      link:'kve/about-us'
    },
    {
      title:"Store Policies",
      link:'kve/policies'
    },
    {
      title:"News Letter",
      link:'kve/news-letter'
    },
    {
      title:"Social Media",
      link:'kve/social-media'
    }
  ] */
  sideBar:HTMLElement;

  @ViewChild('sideBar') sideBarHost:ElementRef<HTMLElement>

  @Output() secondaryMenu:EventEmitter<NbMenuItem[]> = new EventEmitter<NbMenuItem[]>();

  constructor(
    private iconLibraries: NbIconLibraries,
    private editorService:EditorService,
    private nbMenuService:NbMenuService,
    private dialogService: NbDialogService,
    private sideBarService:NbSidebarService,) {
    this.iconLibraries.registerFontPack('fas', { packClass: 'fas', iconClassPrefix: 'fa' });
       this.iconLibraries.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
       this.iconLibraries.registerFontPack('fab', { packClass: 'fab', iconClassPrefix: 'fa' });
       this.iconLibraries.setDefaultPack('far');
       this.nbMenuService.onSubmenuToggle().subscribe(menuBag => {
        
        //console.log(menuBag.item);
        //console.log(menuBag.item.children);
        /* if(menuBag.item.expanded){
          console.log("It's expanded");
        } */
       })
       this.nbMenuService.onItemSelect().subscribe(menuBag => {
        //console.log(menuBag)
        //menuBag.item.children
      })
       this.nbMenuService.onItemClick().subscribe(menuBag => {
        let selectedItem = menuBag.item;
        if(selectedItem != undefined){
          //if(selectedItem.parent.title)
          this.setMenu(selectedItem);
          //console.log({selectedItem:selectedItem});
          if(selectedItem.title == "Sites"){
            let component:Type<any> = SitesPickerComponent;
            this.dialogService.open(component,{
              context:{
                
              }              
            })
          }
          if(menuBag.tag == 'secondary'){
            this.sideBarService.getSidebarState('secondary').subscribe(status => {
              if(status == "expanded"){
                this.sideBarService.collapse('secondary');
              }
            })
            //this.nbMenuService.collapseAll();
          }
        }
        //console.log({menuBag:menuBag,menuGroups:this.menuGroups})
      })
        
       /*  if(menuBag.item.children){
          let item = menuBag.item;
          console.log(menuBag.item.children)
        }
       }) */
       //this.nbMenuInternalService.onGetSelectedItem
   }

  ngOnInit(): void {
    //this.menuGroup.menuItems = this.menuItems;
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.menuItems = this.menuGroups.topLevelMenu.menuItems;
    //console.log(this.menuGroups);
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    /* this.sideBar = this.sideBarHost.nativeElement;
    console.log(this.sideBar);
    let sideBarContainer = <HTMLElement>this.sideBar.children[0];
    sideBarContainer.style.setProperty('background','var(--sidebar-background-color-)');
    sideBarContainer.classList.add('white-background'); */
  }
  
  onToggleSubMenu(e) {
    
    console.log("Submenu toggled");
  }

  setMenu(selectedItem:NbMenuItem){
    //console.log(selectedItem)
    this.menuGroup.menuItems.forEach(menuItem => {
      if(menuItem.title == selectedItem.title && menuItem.children != null){
        //this.previousMenu = this.menuItems;
        //console.log(menuItem.title);
        //let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
        let headerItem:NbMenuItem = {title:menuItem.title}
        headerItem.icon = {icon:"angle-double-left",pack:"fas"}
        //this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        this.secondaryMenuItems = [headerItem].concat(menuItem.children);
        this.secondaryMenu.emit(this.secondaryMenuItems);
      }
    })
    /* if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    } */
    
  }
}
